import { Controller } from "@hotwired/stimulus"

// Scroll-triggered animations + counter animation
// Replaces WOW.js — zero deps, IntersectionObserver-based
export default class extends Controller {
  connect() {
    this.wowEls = this.element.querySelectorAll(".wow")
    this.counterEls = this.element.querySelectorAll(".countup")

    if (this.wowEls.length === 0 && this.counterEls.length === 0) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          const el = entry.target

          if (el.classList.contains("wow")) {
            el.style.visibility = "visible"
            el.classList.add("animated")

            // Animate countup too
            if (el.classList.contains("countup")) {
              this._animateCounter(el)
            }
          }

          if (el.classList.contains("countup")) {
            this._animateCounter(el)
          }

          observer.unobserve(el)
        })
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    )

    this.wowEls.forEach((el) => observer.observe(el))
    this.counterEls.forEach((el) => observer.observe(el))

    this._observer = observer
  }

  disconnect() {
    this._observer?.disconnect()
  }

  _animateCounter(el) {
    const start = parseInt(el.getAttribute("cup-start"), 10) || 0
    const end = parseInt(el.getAttribute("cup-end"), 10)
    const append = el.getAttribute("cup-append") || ""
    const duration = 1500
    const startTime = performance.now()

    el.textContent = start + append

    const tick = (now) => {
      const elapsed = now - startTime
      const progress = Math.min(elapsed / duration, 1)
      const eased = 1 - (1 - progress) * (1 - progress)
      const current = Math.round(start + eased * (end - start))
      el.textContent = current + append
      if (progress < 1) requestAnimationFrame(tick)
    }

    requestAnimationFrame(tick)
  }
}
